export class Cookie {
    constructor(public key: string, public value: string) {}
}
